import { injectable } from "inversify";
import { HlSimpleRevenueEstimation, HlSimpleRevenueEstimationRequestModel } from "@/modules/pricing/model";
import { Bad, OkVal } from "@leavy/result";

@injectable()
export abstract class HlPricingService {
    abstract getPricingEstimation(request: HlSimpleRevenueEstimationRequestModel): Promise<OkVal<HlSimpleRevenueEstimation> | Bad<"ESTIMATION_NOT_POSSIBLE">>;
}
